<div *ngIf="isText">{{messages}}</div>
<div *ngIf="isHtml" [innerHtml]="messages"></div>
<ul *ngIf="isList">
  <li *ngFor="let message of messages">{{message}}</li>
</ul>
<button *ngIf="showCloseButton" mat-icon-button (click)="dismissSnackBar()">
  <mat-icon>close</mat-icon>
</button>